<script lang="ts">
  import Button from './Button.svelte';
  import ThemeIcon from '../themes/ThemeIcon.svelte';

  let {
    id,
    title,
    closeLabel,
    close,
    level = 2,
    initialFocus = 'close',
  }: {
    id: string;
    title: string;
    closeLabel: string;
    close: () => void;
    level?: 1 | 2;
    initialFocus?: 'close' | 'title';
  } = $props();
</script>

<header class="dialog-header">
  <!-- svelte-ignore a11y_autofocus: long read-only dialogs deliberately focus their heading. -->
  <svelte:element this={level === 1 ? 'h1' : 'h2'} {id} tabindex="-1" autofocus={initialFocus === 'title'}>
    {title}
  </svelte:element>
  <!-- svelte-ignore a11y_autofocus: focus the exit rather than opening a mobile keyboard. -->
  <Button
    variant="ghost"
    class="dialog-header-close"
    aria-label={closeLabel}
    title={closeLabel}
    autofocus={initialFocus === 'close'}
    onclick={close}><ThemeIcon name="close" /></Button
  >
</header>

<style>
  .dialog-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-shrink: 0;
    padding: var(--dialog-content-padding);
    padding-bottom: 12px;
  }
  h1,
  h2 {
    margin: 0;
    min-width: 0;
    overflow-wrap: anywhere;
  }
  .dialog-header :global(.dialog-header-close) {
    display: grid;
    place-items: center;
    flex: 0 0 44px;
    width: 44px;
    height: 44px;
    padding: 8px;
    font-size: 26px;
  }
</style>
